<template>
    <div>
      <div class="form-group row">
          <div class="col-sm-6">
              <label class="control-label">{{label}}</label>
              <div v-if="!imagem">
                  <input type="file"
                    @change="onFileChange"
                    :accept="accept">
              </div>
              <div v-else>
                  <img class='img-fluid' :src="imagem" />
                  <button type="button" class="btn btn-danger" @click="removeImage"><i class="far fa-trash-alt"></i> Remover</button>
              </div>
          </div>
          <div class="col-sm-6 text-center" v-if="urlArquivo != ''">
              <label class="control-label">{{label}} Atual</label>
              <span v-if="tipo == 'pdf'"><a :href="urlArquivo" target="_blank">{{ arquivo.key }}</a></span>
              <img v-else class='img-fluid' :src="urlArquivo" />
          </div>
      </div>
    </div>
</template>
<script>
    import Select from './Select'
    import Facade from '../../facade/facade'
    import {isUndefinedOrNullOrEmpty} from '@/services/string';
    import {getFileExtension} from "@/services/util";
    const facade = new Facade();

    export default {
        components: {Select},
        props: {
            label: {
                type: String,
                default: "Imagem"
            },
            arquivo: {
                required: true
            },
            accept: {
              type: String,
              default: "image/x-png, image/jpeg"
            }
        },
        data() {
            return {
                imagem: '',
                file: null
            }
        },
        computed: {
            urlArquivo () {
                if (!isUndefinedOrNullOrEmpty(this.arquivo)) {
                    return this.arquivo.url;
                } else {
                    return '';
                }
            },
            tipo () {
              if (!isUndefinedOrNullOrEmpty(this.arquivo)) {
                return getFileExtension(this.arquivo.key);
              } else {
                  return '';
              }
            }
        },
        methods: {
            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                this.file = files[0];

                if (this.file.type != 'application/pdf') {
                  this.createImage(files[0]);
                }

                this.$emit('input', this.file)
            },
            createImage(file) {
                var image = new Image();
                var reader = new FileReader();
                var vm = this;

                reader.onload = (e) => {
                    vm.imagem = e.target.result;
                };
                reader.readAsDataURL(file);
            },
            removeImage () {
                this.file = '';
                this.imagem = '';
            },
            changeSelect(newVal) {
                this.$emit('input', newVal)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// FileImage.vue?14206b37